import classNames from 'classnames';
import moment from 'moment';
import React from 'react';
import { Link } from 'react-router-dom';
import { getUrlPrefix } from '../../../utils/config';
import { getParticipant, isConversationRead } from '../../../utils/conversationUtil';
import { truncate } from '../../../utils/stringUtil';
import ClickableChevron from './ClickableChevron';
import './ConversationPreviewCard.less';
moment.locale('nb');
var getParticipantName = function (conversation, currentUser) {
    var participant = getParticipant(conversation, currentUser);
    return participant.name || 'Bruker mangler navn';
};
var getConversationPreviewSubHeader = function (currentUser, latestMessage) {
    var createdOn = latestMessage.createdOn;
    if (!createdOn) {
        return '';
    }
    var timeFromNow = moment(createdOn).fromNow();
    if (currentUser.id === latestMessage.senderId) {
        return "Sendt " + timeFromNow;
    }
    return "Mottatt " + timeFromNow;
};
var ConversationPreviewCard = function (props) {
    var _a;
    var conversation = props.conversation, currentUser = props.currentUser, isSelected = props.isSelected, book = props.book;
    var url = getUrlPrefix() + "/chat/" + conversation.slug;
    var participantName = getParticipantName(conversation, currentUser);
    var latestMessage = conversation.latestMessage;
    var coverUrl = book === null || book === void 0 ? void 0 : book.imageUrl;
    var message = truncate((_a = latestMessage === null || latestMessage === void 0 ? void 0 : latestMessage.body) !== null && _a !== void 0 ? _a : '', 80) || '';
    var isConversationUnread = !isConversationRead(conversation, currentUser);
    var className = classNames('conversationpreview', {
        'conversationpreview--unread': isConversationUnread,
        'conversationpreview--selected': isSelected,
    });
    return React.createElement(Link, { to: url, className: className },
        React.createElement("div", { className: "conversationpreview__cover" }, !!coverUrl && React.createElement("img", { src: coverUrl, alt: (book === null || book === void 0 ? void 0 : book.title) || '' })),
        React.createElement("section", { className: "conversationpreview__metadata" },
            React.createElement("h2", null, participantName),
            React.createElement("p", { className: "conversationpreview__metadata__message" }, message),
            React.createElement("em", { className: "conversationpreview__metadata__timestamp" }, getConversationPreviewSubHeader(currentUser, latestMessage))),
        React.createElement(ClickableChevron, null));
};
export default ConversationPreviewCard;
